export default __webpack_public_path__ + "static/media/yle-logo.99a45570.svg";